<template>
	<form @submit.prevent="">
		<div class="form-row">
			<div class="col-12">
				<label for="title">عنوان ویجت</label>
				<input type="text" id="title" placeholder="عنوان ویجت" class="widget-input input-no-bg input-lg input-set-border w-100" v-model="data.title">
			</div>
		</div>
		<div class="form-row">
			<div class="col-12">
				<label for="title"> واچ لیست پیشفرض</label>
				<!-- <select class="form-control t-widget-select widget-select-lg select-set-border" id="title" v-model="data.selected_watchList">
						<option v-for="watchList in data.watchLists"  :key="watchList.id" :value="watchList.id" > {{ watchList.title }} </option>
				</select> -->
				<div class="widget-select w-100 m-top widget-select-lg">
					<v-select v-model="data.selected_watchList" :clearable="false"  label="title"  :reduce="(option) => option.id" :options="data.watchLists">
					</v-select>
				</div>
			</div>
		</div>
		<div class="form-row text-center mt-4">
			<div class="col-12">
				<a href="" @click.prevent="saveSettings()" class="m-left min-w150 tgju-btn tgju-btn-lg tgju-btn-primary"><i class="uil uil-save"></i> ذخیره</a>
			</div>
		</div>
	</form>
</template>

<script>
	import vSelect from 'vue-select'
	Vue.component('v-select', vSelect);

	export default {
		name: 'SettingsWatchList',
		components: {},
		props: ['data'],
		data: function () {
			return {}
		},

		mounted() {
			this.$watch('data', function(newValue, oldValue) {
				this.data.watchLists.push({
					id:0,
					title:"انتخاب کنید"
				});

			}, {immediate: true});
		},

		methods: {
			saveSettings() {
				let data = this.$helpers.unbindObject(this.data);
								
				this.$parent.saveSettings({
					title : this.data.title,
					data : { 
						selected_watchList : this.data.selected_watchList
					},
				});
			}
		},
	}
</script>